import {Box} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import type {DigitalSigningStatus} from "../../digitalSigning/public/digitalSigning.types";
import {ElementChip} from "./base/ElementChip";
import {StatusDot} from "./base/StatusDot";
import {getDigitalSigningStatusColor} from "./colors";

/** Every status, in the order of a signing's life - the list's filter offers them so. */
export const DIGITAL_SIGNING_STATUSES: DigitalSigningStatus[] = ['PENDING', 'OPENED', 'SIGNED', 'CONFIRMED', 'VOIDED', 'EXPIRED'];

export const DIGITAL_SIGNING_STATUS_LABEL_KEYS: Record<DigitalSigningStatus, string> = {
    PENDING: 'Pending',
    OPENED: 'Opened',
    SIGNED: 'Signed',
    CONFIRMED: 'Confirmed',
    VOIDED: 'Voided',
    EXPIRED: 'Expired',
};

interface DigitalSigningStatusElementProps {
    status: DigitalSigningStatus | undefined;
    asPrint?: boolean;
}

/** A signing's status in a list or a header, like the reservation's and the folio's. */
export function DigitalSigningStatusElement({status, asPrint = false}: DigitalSigningStatusElementProps) {
    const {t} = useTranslation();

    if (!status) {
        return null;
    }

    const text = t(DIGITAL_SIGNING_STATUS_LABEL_KEYS[status] ?? status);

    if (asPrint) {
        return <>{text}</>;
    }

    return (
        <Box sx={{display: "inline-flex", maxWidth: "100%"}}>
            <ElementChip text={text} startIcon={<StatusDot color={getDigitalSigningStatusColor(status)}/>}/>
        </Box>
    );
}
